import React from 'react';
import { Box, Typography } from '@mui/material';
import { useColorMode } from '../contexts/ColorModeContext';

/**
 * The ShoutVector logo, readable in either colour mode.
 *
 * shoutvector_logo.png has navy lettering that vanishes on a dark background, so in dark mode
 * this shows the symbol with the name set in the theme's text colour. Use this rather than the
 * PNG directly anywhere the logo appears.
 */
export const BrandLogo: React.FC<{ height?: number; maxWidth?: number }> = ({ height = 40, maxWidth }) => {
  const { mode } = useColorMode();
  if (mode === 'dark') {
    return (
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
        <img src="/shoutvector_logo_sym.png" alt="" style={{ height: height * 0.9, width: 'auto' }} />
        <Typography component="span" sx={{ fontWeight: 700, color: 'text.primary', fontSize: height * 0.5 }}>
          ShoutVector
        </Typography>
      </Box>
    );
  }
  return (
    <img
      src="/shoutvector_logo.png"
      alt="ShoutVector"
      style={maxWidth ? { maxWidth, width: '100%', height: 'auto' } : { height, width: 'auto' }}
    />
  );
};
